const married = { id: 1, value: 'MARRIED', text: 'Casado' }
const divorced = { id: 2, value: 'DIVORCED', text: 'Divorciado' }
const single = { id: 3, value: 'SINGLE', text: 'Solteiro' }
const widowed = { id: 4, value: 'WIDOWED', text: 'Viuvo' }
const separated = { id: 5, value: 'SEPARATED', text: 'Separado' }
const uninformed = { id: 6, value: 'UNINFORMED', text: 'Não Informado' }

export const options = [
  married,
  divorced,
  single,
  widowed,
  separated,
  uninformed
]

export const getById = idToFind =>
  options.find(({ id }) => id === idToFind) || uninformed

export default { options, getById }



// WEBPACK FOOTER //
// ./src/Participant/maritalStatuses.js